export const cn = {
    currentPlan: '当前方案',
    month: '月',
    year: '年',
    billingCycle: {
        monthly: '月付',
        yearly: '年付',
        saveAmount: '节省{amount}',
    },
    recommend: '最受欢迎',
    subscriptionExists: '您已经有一个有效的订阅',
    plans: {
        basic: {
            name: '基础版',
            price: '免费',
            description: '适合验证研究假设或体验平台的个人用户',
            featuresHeader: '方案功能:',
            features: {
                0: 'Lead化合物分析：共 5 次',
                1: '文档精读：每天 10 个文档 — 每日上限 Conference 2 次 / H2H 2 次（每次至多上传 2 个文档）',
                2: 'SAR数据提取：每天 2 个文档',
                3: '2份AI驱动情报简报，提前捕捉市场信号',
            },
        },
        pro: {
            name: '专业版',
            description: '为科研工作者提供完整的研究能力',
            buttonText: '升级',
            featureGroupHeader: '包含基础版全部功能，配以更高用量与开放导出：',
            featureGroupHeaderEconomy: '包含基础版全部功能，全功能解锁，配以科研级月度配额：',
            featureGroups: [
                {
                    features: {
                        0: 'Lead化合物分析开放导出（每月 5 次）',
                        2: '文档精读：每天 50 个文档 — 每日上限 Conference 5 次 / H2H 5 次（每次至多上传 5 个文档）',
                        3: 'SAR数据提取：每天 5 个文档',
                        4: '5 份AI驱动情报简报（每周更新）',
                        economy_0: 'Lead化合物分析：每月 3 次',
                    },
                }
            ],
        },
        enterprise: {
            name: '企业版',
            description: '赋能全团队的科研发现',
            buttonText: '预约演示',
            price: '联系我们',
            featureGroupHeader: '包含专业版全部功能，以及：',
            featureGroups: [
                {
                    header: '深度科研',
                    features: {
                        0: 'SAR提取即将上线',
                        1: '结构到马库什智能体的关联通路',
                        economy_0: 'Lead化合物分析：每年 60 次',
                        economy_1: '文档精读：每天 200 个文档',
                        economy_2: '额外专家智能体：抗体抗原筛选、马库什撰写、知产报告',
                    },
                },
                {
                    header: '能力扩展',
                    features: {
                        0: '更高用量配额与更高性能模型',
                        1: '内置科研记录系统',
                        2: '全格式文件导出（FASTA、SDF、SMILES）',
                        3: '额外专家智能体（知产报告、抗体抗原筛选、马库什撰写）',
                    },
                },
                {
                    header: '安全与管控',
                    features: {
                        0: '共享项目',
                        1: '团队协作',
                        2: '企业级安全与SSO及管理员控制',
                        3: '专属客户支持',
                    },
                }
            ],
        },
        api: {
            name: 'API',
            description: '让智能体融入您的研究工作流',
            buttonText: '了解更多',
            price: '定制化报价',
            featuresHeader: '包含专业版,以及:',
            features: {
                0: '即插即用部署，按用量灵活计费',
                1: '通过API、组件和连接器直接嵌入现有工作流',
                2: '借助 Agent Skills 与 MCP 大幅提升智能体能力',
                3: '从底层构建企业级安全架构',
            },
        },
    },
}

export const en = {
    currentPlan: 'Current Plan',
    month: 'month',
    year: 'year',
    billingCycle: {
        monthly: 'Monthly',
        yearly: 'Yearly',
        saveAmount: 'Save {amount}',
    },
    recommend: 'MOST POPULAR',
    subscriptionExists: 'You already have an active subscription',
    plans: {
        basic: {
            name: 'Basic',
            description: 'Ideal for individuals validating a hypothesis or testing the platform',
            featuresHeader: 'Plan Features:',
            price: 'Free',
            features: {
                0: 'Lead Compound: 5 runs total​',
                1: 'Document Analyzer: 10 docs/day — daily max of 2 Conference, 2 H2H (2 docs/upload)​',
                2: 'SAR Data Extraction: 2 docs/day​',
                3: '2 AI-enabled Pulse briefs to spot market signals early',
            },
        },
        pro: {
            name: 'Pro',
            description: 'Full research capabilities for working scientists',
            buttonText: 'Upgrade',
            featureGroupHeader: 'Everything in Basic, with expanded monthly limits and exports:',
            featureGroupHeaderEconomy: 'Everything in Basic, fully unlocked with research-scale monthly limits:',
            featureGroups: [
                {
                    features: {
                        0: 'Export enabled for Lead Compound (5 runs/month)​',
                        2: 'Document Analyzer: 50 docs/day — daily max of 5 Conference, 5 H2H (5 docs/upload)​',
                        3: 'SAR Data Extraction: 5 docs/day',
                        4: '5 weekly AI-enabled Pulse Briefings',
                        economy_0: 'Lead Compound: 3 runs/month',
                    },
                }
            ],
        },
        enterprise: {
            name: 'Enterprise',
            description: 'Scale discovery across your whole team',
            buttonText: 'Book a Demo',
            price: 'Contact us',
            featureGroupHeader: 'Everything in pro, plus:',
            featureGroups: [
                {
                    header: 'Deep Science​',
                    features: {
                        0: 'SAR extraction​ coming soon​​',
                        1: 'Connection from Structures to Markush agent​​',
                        economy_0: 'Lead Compound: 60 runs/yr​​',
                        economy_1: 'Document Analyzer: 200 docs/day​​',
                        economy_2: 'Expert AI agents: Antibody-Target Predictor, Markush Claim Drafting, Pharma CI Explorer​​',
                    },
                },
                {
                    header: 'Expanded Capabilities​',
                    features: {
                        0: 'Increased usage with higher-tier model performance​',
                        1: 'Built-in system of record​',
                        2: 'Full file exports (FASTA, SDF,SMILES)​',
                        3: 'Additional expert AI agents (Antibody Target Predictor, Markush Claim Drafting, Pharma CI Explorer))​',
                    },
                },
                {
                    header: 'Security & Control',
                    features: {
                        0: 'Shared projects​',
                        1: 'Team collaboration​',
                        2: 'Enterprise security with SSO and admin controls​',
                        3: 'Dedicated Customer Support',
                    },
                }
            ],
        },
        api: {
            name: 'API',
            description: 'Embed agents into your research infrastructure',
            buttonText: 'Learn more',
            price: 'Custom',
            featuresHeader: 'Includes Pro, plus:',
            features: {
                0: 'Plug-and-play deployment with flexible, usage-based pricing',
                1: 'Embed directly into your existing workflows through APIs, widgets, and connectors',
                2: 'Supercharge agent performance with Agent Skills and MCPs',
                3: 'Built with enterprise-grade security at its core',
            },
        },
    },
}

export const tw = {
    currentPlan: '目前方案',
    month: '月',
    year: '年',
    billingCycle: {
        monthly: '月付',
        yearly: '年付',
        saveAmount: '節省{amount}',
    },
    recommend: '最受歡迎',
    subscriptionExists: '您已經有一個有效的訂閱',
    plans: {
        basic: {
            name: '基礎版',
            price: '免費',
            description: '適合驗證研究假設或體驗平台的個人用戶',
            featuresHeader: '方案功能:',
            features: {
                0: 'Lead化合物分析：共 5 次',
                1: '文檔精讀：每天 10 個文檔 — 每日上限 Conference 2 次 / H2H 2 次（每次至多上傳 2 個文檔）',
                2: 'SAR數據提取：每天 2 個文檔',
                3: '2份AI驅動情報簡報，提前捕捉市場訊號',
            },
        },
        pro: {
            name: '專業版',
            description: '為科研工作者提供完整的研究能力',
            buttonText: '升級',
            featureGroupHeader: '包含基礎版全部功能，配以更高用量與開放導出：',
            featureGroupHeaderEconomy: '包含基礎版全部功能，全功能解鎖，配以科研級月度配額：',
            featureGroups: [
                {
                    features: {
                        0: 'Lead化合物分析開放導出（每月 5 次）',
                        2: '文檔精讀：每天 50 個文檔 — 每日上限 Conference 5 次 / H2H 5 次（每次至多上傳 5 個文檔）',
                        3: 'SAR數據提取：每天 5 個文檔',
                        4: '5份AI驅動情報簡報（每週更新）',
                        economy_0: 'Lead化合物分析：每月 3 次',
                    },
                }
            ],
        },
        enterprise: {
            name: '企業版',
            description: '賦能全團隊的科研發現',
            buttonText: '預約示範',
            price: '聯繫我們',
            featureGroupHeader: '包含專業版全部功能，以及：',
            featureGroups: [
                {
                    header: '深度科研',
                    features: {
                        0: 'SAR提取即將上線',
                        1: '結構到馬庫什智能體的關聯通路',
                        economy_0: 'Lead化合物分析：每年 60 次',
                        economy_1: '文檔精讀：每天 200 個文檔',
                        economy_2: '額外專家智能體：抗體抗原篩選、馬庫什撰寫、知產報告',
                    },
                },
                {
                    header: '能力擴展',
                    features: {
                        0: '更高用量配額與更高效能模型',
                        1: '內建科研記錄系統',
                        2: '全格式檔案導出（FASTA、SDF、SMILES）',
                        3: '額外專家智能體（知產報告、抗體抗原篩選、馬庫什撰寫）',
                    },
                },
                {
                    header: '安全與管控',
                    features: {
                        0: '共享項目',
                        1: '團隊協作',
                        2: '企業級安全與SSO及管理員控制',
                        3: '專屬客戶支持',
                    },
                }
            ],
        },
        api: {
            name: 'API',
            description: '讓智能體融入您的研究工作流',
            buttonText: '了解更多',
            price: '客製化報價',
            featuresHeader: '包含專業版,以及:',
            features: {
                0: '即插即用部署，按用量靈活計費',
                1: '透過API、元件和連接器直接嵌入現有工作流',
                2: '藉助Agent Skills與MCP大幅提升智能體能力',
                3: '從底層構建企業級安全架構',
            },
        },
    },
}

export const jp = {
    currentPlan: '現在のプラン',
    month: '月',
    year: '年',
    billingCycle: {
        monthly: '月払い',
        yearly: '年払い',
        saveAmount: '{amount} お得',
    },
    recommend: '最も人気',
    subscriptionExists: '既にアクティブなサブスクリプションがあります',
    plans: {
        basic: {
            name: 'ベーシック',
            price: '無料',
            description: '仮説検証やプラットフォーム体験に最適な個人向けプラン',
            featuresHeader: 'プラン機能:',
            features: {
                0: 'Lead化合物分析：合計 5 回',
                1: 'ドキュメント精読：1 日 10 ドキュメント — 1 日あたり上限 Conference 2 回 / H2H 2 回（1 回あたり最大 2 ドキュメント）',
                2: 'SAR データ抽出：1 日 2 ドキュメント',
                3: '2件のAI駆動インテリジェンスブリーフ、市場シグナルをいち早くキャッチ',
            },
        },
        pro: {
            name: 'プロ',
            description: '研究者のための本格的なリサーチ機能',
            buttonText: 'アップグレード',
            featureGroupHeader: 'ベーシックの全機能に加え、月次利用枠の拡大とエクスポート開放：',
            featureGroupHeaderEconomy: 'ベーシックの全機能を完全解放、リサーチスケールの月次利用枠:',
            featureGroups: [
                {
                    features: {
                        0: 'Lead化合物分析のエクスポート機能を開放（月 5 回）',
                        2: 'ドキュメント精読：1 日 50 ドキュメント — 1 日あたり上限 Conference 5 回 / H2H 5 回（1 回あたり最大 5 ドキュメント）',
                        3: 'SAR データ抽出：1 日 5 ドキュメント',
                        4: '5件のAI駆動インテリジェンスブリーフ（毎週更新）',
                        economy_0: 'Lead化合物分析：月 3 回',
                    },
                }
            ],
        },
        enterprise: {
            name: 'エンタープライズ',
            description: 'チーム全体の創薬ディスカバリーを加速',
            buttonText: 'デモを予約',
            price: 'お問い合わせ',
            featureGroupHeader: 'プロの全機能に加えて：',
            featureGroups: [
                {
                    header: 'ディープサイエンス',
                    features: {
                        0: 'SAR抽出近日公開',
                        1: '構造からマーカッシュエージェントへの連携パス',
                        economy_0: 'Lead化合物分析：年 60 回',
                        economy_1: 'ドキュメント精読：1 日 200 ドキュメント',
                        economy_2: '追加エキスパートエージェント：抗体抗原スクリーニング、マーカッシュ起草、知財レポート',
                    },
                },
                {
                    header: '能力拡張',
                    features: {
                        0: 'より多い利用枠と高性能モデル',
                        1: '内蔵の研究記録システム',
                        2: '全フォーマットファイルエクスポート（FASTA、SDF、SMILES）',
                        3: '追加エキスパートエージェント（知財レポート、抗体抗原スクリーニング、マーカッシュ起草）',
                    },
                },
                {
                    header: 'セキュリティと管理',
                    features: {
                        0: '共有プロジェクト',
                        1: 'チームコラボレーション',
                        2: 'SSOおよび管理者コントロールを備えたエンタープライズセキュリティ',
                        3: '専任カスタマーサポート',
                    },
                }
            ],
        },
        api: {
            name: 'API',
            description: 'エージェントを研究ワークフローに統合',
            buttonText: '詳細を見る',
            price: 'カスタム見積もり',
            featuresHeader: 'プロ版に加えて:',
            features: {
                0: 'プラグアンドプレイで導入、従量課金で柔軟に運用',
                1: 'API・ウィジェット・コネクタで既存ワークフローに直接組み込み',
                2: 'Agent SkillsとMCPでエージェント性能を大幅強化',
                3: 'エンタープライズグレードのセキュリティを基盤から構築',
            },
        },
    },
}
